import React from 'react';

import CButton from '../../components/CButton';
import CLocalizedText from '../../components/CLocalizedText';
import CModal from '../../components/CModal';
import XDCheckbox from '../../components/forms/XDCheckbox';
import { type ETableIds } from '../../enums/ETableIds';

type TColumnToggle = boolean | null;

interface Props {
  id: ETableIds;
  open: boolean;
  toggleableColumns: Array<{ column: string; ix: number }>;
  modalColumnToggleArray: TColumnToggle[];
  onClose: () => void;
  onApply: () => void;
  onColumnToggleChange: (columnIndex: number, checked: boolean) => void;
}

export default function CBrowsableTableColumnToggleModal(props: Props) {
  return (
    <CModal open={props.open} onClose={props.onClose}>
      <div className={'flex flex-col gap-4'}>
        <div className={'flex flex-col gap-2'}>
          {props.toggleableColumns.map(({ column, ix }) => (
            <XDCheckbox
              key={`${props.id}-column-toggle-${ix}`}
              checked={props.modalColumnToggleArray[ix] === true}
              onChange={(ev) => {
                props.onColumnToggleChange(ix, ev.target.checked);
              }}
            >
              {column}
            </XDCheckbox>
          ))}
        </div>
        <div className={'flex justify-end gap-2'}>
          <CButton onClick={props.onClose} isForm style={{ borderWidth: 1, width: '100%', justifyContent: 'center' }}>
            <CLocalizedText dictKey={'global.cancel'} />
          </CButton>
          <CButton onClick={props.onApply} isForm style={{ borderWidth: 1, width: '100%', justifyContent: 'center' }}>
            <CLocalizedText dictKey={'global.apply'} />
          </CButton>
        </div>
      </div>
    </CModal>
  );
}
